export default __webpack_public_path__ + "static/media/money_charge.82a6aee5.png";